import {createAction} from '@reduxjs/toolkit';
import {OrderingFilters, PaginatedTableFilters} from 'store/home/type';

export const enum PRENOTAZIONI_TABLE_ACTION {
    SET_PAGE_INDEX = 'PRENOTAZIONI_SET_PAGE_INDEX',
    SET_PAGE_SIZE = 'PRENOTAZIONI_SET_PAGE_SIZE',
    SET_FILTERS = 'PRENOTAZIONI_SET_FILTERS',
    SET_ORDERING_FILTERS = 'PRENOTAZIONI_SET_ORDERING_FILTERS',
}

const setPageIndexAction = createAction(PRENOTAZIONI_TABLE_ACTION.SET_PAGE_INDEX, (payload:number) => {
    return {payload}
})

const setPageSizeAction = createAction(PRENOTAZIONI_TABLE_ACTION.SET_PAGE_SIZE, (payload:number) => {
    return {payload}
})

const setFiltersAction = createAction(PRENOTAZIONI_TABLE_ACTION.SET_FILTERS, (payload:PaginatedTableFilters) => {
    return {payload}
})

const setOrderingFiltersAction = createAction(PRENOTAZIONI_TABLE_ACTION.SET_ORDERING_FILTERS, (payload:OrderingFilters) => {
    return {payload}
})

export const PrenotazioniTableAction = {
    setPageIndexAction,
    setPageSizeAction,
    setFiltersAction,
    setOrderingFiltersAction
};
